import { Routes } from '@angular/router';
import { sessionGuard } from '../../guards/session.guard';
import { adminRoutes } from './admin/admin.routes';
import { clientsRoutes } from './clients/clients.routes';
import { paymentsRoutes } from './payments/payments.routes';
import { quoteTemplateRoutes } from './quote-templates/quote-template.routes';
import { quotesRoutes } from './quotes/quotes.routes';

export const dashboardRoutes: Routes = [
  {
    canActivate: [sessionGuard],
    children: adminRoutes,
    path: 'admin',
  },
  {
    canActivate: [sessionGuard],
    children: clientsRoutes,
    path: 'clients',
  },
  {
    canActivate: [sessionGuard],
    data: { key: 'company' },
    loadComponent: () => import('./company/company.page').then((m) => m.CompanyPage),
    path: 'company',
  },
  {
    canActivate: [sessionGuard],
    data: { key: 'home' },
    loadComponent: () => import('./home/home.page').then((m) => m.HomePage),
    path: 'home',
  },
  {
    canActivate: [sessionGuard],
    children: paymentsRoutes,
    path: 'payments',
  },
  {
    canActivate: [sessionGuard],
    children: quoteTemplateRoutes,
    path: 'quote-templates',
  },
  {
    canActivate: [sessionGuard],
    children: quotesRoutes,
    path: 'quotes',
  },
  {
    canActivate: [sessionGuard],
    loadComponent: () => import('./test-prompt/test-prompt.page').then((m) => m.TestPromptPage),
    path: 'test-prompt',
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: 'home',
  },
];
